import { Layout, theme } from "antd";
import Footers from "../components/Footer";
import Headers from "../components/Header";
import Siders from "../components/Sider";
import React from "react";
import Notifications from "../components/Notifications";
import App from "../components/Stats";

const { Content } = Layout;

const NotificationsPage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Siders />
      <Layout>
        <Headers />
        <Content className="site-layout">
          <App />
          <br />
          <div
            style={{
              padding: 24,
              minHeight: 380,
              background: colorBgContainer,
            }}
          >
            <Notifications />
          </div>
        </Content>
        <Footers />
      </Layout>
    </Layout>
  );
};

export default NotificationsPage;
